import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './ArtFlow.css';
import artflowimage from '../../assets/pageimages/ArtFlow.webp';

function ArtFlowHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>ArtFlow</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/artflow-library" className="top-button-link"><FontAwesomeIcon icon={faSchoolCircleCheck} className="artflow-bottomlink-style" />Library</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="artflow-bottomlink-style" />My Artbook</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-create-master" className="top-button-link"><FontAwesomeIcon icon={faPlusSquare} className="artflow-bottomlink-style" />Create Master</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-changes" className="top-button-link"><FontAwesomeIcon icon={faEdit} className="artflow-bottomlink-style" />Change History</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-comments" className="top-button-link"><FontAwesomeIcon icon={faComment} className="artflow-bottomlink-style" />Comments</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-followups" className="top-button-link"><FontAwesomeIcon icon={faRedo} className="artflow-bottomlink-style" />Followups</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-approvals" className="top-button-link"><FontAwesomeIcon icon={faFistRaised} className="artflow-bottomlink-style" />Approvals</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-development" className="top-button-link"><FontAwesomeIcon icon={faGlassMartini} className="artflow-bottomlink-style" />Development</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-ecommerce" className="top-button-link"><FontAwesomeIcon icon={faCartShopping} className="artflow-bottomlink-style" />E-stores</Link></div>
              <div className="bottom-buttons-box"><Link to="/artflow-exhibitions" className="top-button-link"><FontAwesomeIcon icon={faShower} className="artflow-bottomlink-style" />Exhibitions</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="artflow-id" src={artflowimage} alt="ArtFlow Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ArtFlowHome;
